import React, { useEffect, useState, useRef } from 'react';
import { NavLink, useNavigate, useLocation, Link, useParams } from "react-router-dom"
import Slider from '../../components/slider/Slider';
import service1 from '../../assets/images/services/1.png';
import service2 from '../../assets/images/services/2.png';
import service3 from '../../assets/images/services/3.png';
import ResearchImg from '../../assets/images/icon/research.png';
import RequestImg from '../../assets/images/icon/request-for-proposal.png';
import PickUpImg from '../../assets/images/icon/pickup.png';
import PhoneImg from '../../assets/images/icon/phone.png';
import WalletImg from '../../assets/images/icon/wallet.png';
import VerifyImg from '../../assets/images/icon/verification.png';
import RecommendationImg from '../../assets/images/icon/recommendation.png';
import DiscountImg from '../../assets/images/icon/discount.png';
import CardPaymentImg from '../../assets/images/icon/card-payment.png';
import BestPrice from '../../assets/images/icon/best-price.png';
import Shield from '../../assets/images/icon/shield.png';
import DeliveryMan from '../../assets/images/icon/delivery-man.png';
import sellMobileIcon from '../../assets/images/icon/sell-mobile.png';
import buyMobileIcon from '../../assets/images/icon/buy-mobile.png';
import repairMobileIcon from '../../assets/images/icon/repair-mobile.png';
import TestimonialSlider from "../../components/testimonial-slider/TestimonialSlider";


import '../../index.css';

const Home = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const navigate = useNavigate();
    const { city } = useParams();
    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setSearchQuery(value);
        if (event.key === 'Enter') {
            event.preventDefault(); // Prevent form submission when Enter is pressed
            navigate(`/search-result/${searchQuery}`)
        }
    };
    const handleSubmit = (event) => {
        event.preventDefault(); // This will prevent the default form submission behavior
        navigate(`/search-result/${searchQuery}`)
    };

    return (
        <>
            <div className='container'>
                <Slider />
            </div>
            <div className="container mt-5 mb-0">

                <div className="col-lg-12 col-12  actionGrid text-center" style={{ padding: "10px" }}>
                    <div className="card-header text-center">
                        <h6 className="m-0 p-0">What would you like to do?</h6>
                    </div>
                    <div className="col-lg-12 col-12">
                        <div className='row' style={{ justifyContent: "center" }}>
                            <div className="col-lg-4 col-md-6 col-6 mb-0 mb-lg-0 pt-3 " style={{ borderRight: "1px solid rgba(24, 28, 33, 0.06)" }}>
                                <Link to="/sell-mobile" className="card1 cardbgChange" title="Sell your old or used mobile phone for instant cash">

                                    <div className="custom-block-image-wrap">
                                        <img src={sellMobileIcon} className="img-fluid m-ScreenImg-icon" alt="Sell Mobile" width={100} height={100} />
                                        <h2 className="medium pt-2 pb-3 font_size1rem font-weight-normal">Sell Mobile</h2>

                                    </div>
                                </Link>
                            </div>
                            <div className="col-lg-4 col-md-6 col-6 mb-4 mb-lg-0 pt-3" style={{ borderRight: "1px solid rgba(24, 28, 33, 0.06)" }}>
                                <Link to="/buy-mobile" className="card1 cardbgChange" title="Buy Mobile Service">
                                    <div className="custom-block-image-wrap">
                                        <img src={buyMobileIcon} className="img-fluid m-ScreenImg-icon" alt="Buy Mobile" />
                                        <div className="medium  pt-2 pb-3">Buy Mobile</div>

                                    </div>
                                </Link>
                            </div>
                            <div className="col-lg-4 col-md-6 col-6 mb-4 mb-lg-0 pt-3">
                                <Link to="/buy-mobile" className="card1 cardbgChange" title="Repair Mobile Service">
                                    <div className="custom-block-image-wrap">
                                        <img src={repairMobileIcon} className="img-fluid m-ScreenImg-icon" alt="Repair Mobile" width={100} height={100} />
                                        <h2 className="medium  pt-2 pb-3 font_size1rem font-weight-normal">Repair Mobile</h2>

                                    </div>
                                </Link>
                            </div>
                        </div>
                    </div>

                </div>

            </div>

            <section className="about-section section-padding" id="section_2">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12 mx-auto">
                            <div className="pb-0 mb-0">
                                <div className="section-title-wrap mb-4">
                                    <h4 className="section-title">  Sell Your Old Devices for Instant Cash with CellCash.in
                                    </h4>
                                </div>

                                <p>Looking to sell mobile online in Hyderabad? CellCash.in offers the fastest and most
                                    convenient way to get instant cash for your old or used mobile phone. With our quick
                                    doorstep pickup service, you don’t have to step out or go through complicated processes.
                                    Just enter your device details, get an instant quote, and enjoy a hassle-free selling
                                    experience at the best market price.

                                </p>

                                <p>
                                    Our platform makes selling used gadgets simple and efficient. Whether you want to sell
                                    mobile phones online in Hyderabad, trade in a second-hand laptop, or sell a pre-owned tablet
                                    or smartwatch, you can do it in just a few clicks. Simply select your device brand, provide the
                                    necessary details, and receive an immediate price estimate. No waiting, no hidden
                                    charges—just a seamless process designed for your ease.
                                </p>
                                <p>
                                    With CellCash.in, you can sell mobile online in Hyderabad or any other device from the
                                    comfort of your home or workplace, choosing a pickup time that suits you. Our secure and
                                    transparent system ensures that you get the best value for your used electronics instantly.
                                    Experience the fastest way to trade your old gadgets—sell smart, sell fast with CellCash.in!
                                </p>

                            </div>
                        </div>



                    </div>
                </div>
            </section>


            {/* <section className="trending-podcast-section section-padding">
                <div className="container">
                    <div className="row services-Desktop" >

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">Our Services</h4>
                            </div>
                        </div>
                        <div className="row" >
                            <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service1} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>


                                </div>
                            </div>

                            <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service2} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>

                                </div>
                            </div>

                            <div className="col-lg-4 col-12">
                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service3} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                    <div className="services-Mobile" >

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">Our Services</h4>
                            </div>
                        </div>
                        <div className="services-scroll">
                            <div className="mb-0 mb-lg-0 service-size">
                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service1} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>


                                </div>
                            </div>

                            <div className="mb-0 mb-lg-0 service-size">

                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service2} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>

                                </div>
                            </div>
                            <div className="mb-0 mb-lg-0 service-size">

                                <div className="custom-block custom-block-full p0">
                                    <div className="custom-block-image-wrap">
                                        <NavLink to="/" >
                                            <img src={service3} className="custom-block-image img-fluid"
                                                alt="" />
                                        </NavLink>
                                    </div>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section> */}
            <section className="trending-podcast-section section-padding bgImage">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">How Cellcash Works</h4>
                            </div>
                        </div>


                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fff" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={ResearchImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Choose Device
                                        </h4>
                                        <p className="mb-0">Find the item that you wish to sell by visiting out website or App</p>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={RequestImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Instant Quote
                                        </h4>
                                        <p className="mb-0">Answer few questions on your device condition and get instant quote</p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={PickUpImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Schedule Pickup
                                        </h4>
                                        <p className="mb-0">
                                            Provide your details and choose preferred pick up date time slot to place an order with us
                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                        {/* <div className="col-lg-4 col-12 mt-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={PhoneImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Pickup Call

                                        </h4>
                                        <p className="mb-0">
                                            Pick up executive will call you for door step pick up of your device.


                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        {/* <div className="col-lg-4 col-12 mt-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={VerifyImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Verification
                                        </h4>
                                        <p className="mb-0">
                                            Get diagnosis of device and verification of your identity.


                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div> */}
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p10 hiw-custom-block" style={{ borderRadius: "9px", backgroundColor: "fcfbfd" }}>
                                <div className='row'>
                                    <div className="custom-block-image-wrap textcenter col-lg-3">
                                        <img src={WalletImg} className="img-fluid hitwIcon" alt="" width={100} height={100} />
                                    </div>
                                    <div className="custom-block-info card-padding col-lg-9">
                                        <h4 className="mb-0">
                                            Get Paid

                                        </h4>
                                        <p className="mb-0">
                                            Get paid as soon as our executive verified your device? Its instant payment all the way!

                                        </p>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="trending-podcast-section section-padding">
                <div className="container">
                    <div className="row">

                        <div className="col-lg-12 col-12">
                            <div className="section-title-wrap mb-4">
                                <h4 className="section-title">Why Choose Cellcash?</h4>
                            </div>
                        </div>

                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter" style={{ padding: "0px" }}>

                                    <img src={BestPrice} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info" style={{ height: "252px" }}>
                                    <h4 className="mb-2">
                                        Best Price Guaranteed
                                    </h4>



                                    <p className="mb-14">Seal the deal in just few simple steps! Get a price offer, fix a convenient location for pickup and finally, receive payment before the phone leaves your hands.</p>

                                    <p className="mb-10"></p>
                                </div>


                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter">

                                    <img src={Shield} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info">
                                    <h4 className="mb-2">
                                        100% Safe & Hassle-Free
                                    </h4>



                                    <p className="mb-0">Based on phone brand, specs, age, condition and market forces this intelligent dynamic tool will delight you with a price that goes far beyond your expectations. No pesky phone calls, no haggling or negotiations.</p>


                                </div>


                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-4 mb-lg-0">
                            <div className="custom-block custom-block-full p30 wu-custom-block">
                                <div className="custom-block-image-wrap textcenter">

                                    <img src={DeliveryMan} className="img-fluid" alt="" width={130} height={200} />

                                </div>

                                <div className="custom-block-info" style={{ height: "252px" }}>
                                    <h4 className="mb-2">
                                        Free Doorstep Pickup
                                    </h4>



                                    <p className="mb-0">
                                        Our money transfers are digital. Get your money via Bank Account or Paytm, instantly, before your phone leaves your hands. We keep all your financial details confidential and never share any data
                                    </p>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="cta-section">
                <h1>Join Cellcash as a Partner</h1>
                <p>Partner with us to grow your business. Fill out the form and become a trusted partner!</p>
                <Link to="/partner-form" className="btn-cta mt-3" title="Join CellCash and grow your business">Become a Partner</Link>
            </div>
            <div className="container mt-5">
                <h2 className="text-center mb-4">What Our Customers Say</h2>
                <TestimonialSlider />
            </div>
            <section className="about-section section-padding" id="section_2">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-12 mx-auto">
                            <div className="pb-0 mb-0">
                                <div className="section-title-wrap mb-4">
                                    <h4 className="section-title">FAQs</h4>
                                </div>

                                <h6>Frequently Asked Questions (FAQs) for Cellcash.in</h6>

                                <div className="accordion" id="faqAccordion">
                                    {/* FAQ 1 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading1">
                                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse1" aria-expanded="true" aria-controls="faqCollapse1">
                                                1. How does Cellcash.in determine the value of my mobile device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse1" className="accordion-collapse collapse show" aria-labelledby="faqHeading1" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We evaluate your mobile device based on several factors including the brand, model, variant, age, functional condition, and physical appearance. You'll be asked to fill out a detailed questionnaire on our website which helps us determine the exact condition of your device and offer you a fair market price.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 2 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading2">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse2" aria-expanded="false" aria-controls="faqCollapse2">
                                                2. What types of mobile devices does Cellcash.in accept?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse2" className="accordion-collapse collapse" aria-labelledby="faqHeading2" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We accept a wide range of mobile devices from various brands and models. You can enter your device’s details on our website to check if we currently accept your model.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 3 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading3">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse3" aria-expanded="false" aria-controls="faqCollapse3">
                                                3. Is my personal information safe with Cellcash.in?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse3" className="accordion-collapse collapse" aria-labelledby="faqHeading3" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes, protecting your personal information is our top priority. We implement reasonable security measures to protect your data from unauthorized access, use, or disclosure. Please refer to our Privacy Policy for more detailed information.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 4 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading4">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse4" aria-expanded="false" aria-controls="faqCollapse4">
                                                4. How do I schedule a pickup for my device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse4" className="accordion-collapse collapse" aria-labelledby="faqHeading4" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Once you receive a valuation for your mobile device and accept the offer, you can schedule a pickup by entering your address and choosing a convenient date and time through our website.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 5 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading5">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse5" aria-expanded="false" aria-controls="faqCollapse5">
                                                5. Can I cancel my request after scheduling a pickup?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse5" className="accordion-collapse collapse" aria-labelledby="faqHeading5" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                Yes, you can cancel your pickup request at any time before the scheduled pickup time. Please contact our customer support to cancel or reschedule.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 6 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading6">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse6" aria-expanded="false" aria-controls="faqCollapse6">
                                                6. How and when will I get paid for my device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse6" className="accordion-collapse collapse" aria-labelledby="faqHeading6" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                After our representative confirms the condition of your mobile device at your location, payment will be processed immediately via your preferred method—bank transfer, mobile wallet, or cheque.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 7 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading7">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse7" aria-expanded="false" aria-controls="faqCollapse7">
                                                7. What should I do before handing over my mobile device?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse7" className="accordion-collapse collapse" aria-labelledby="faqHeading7" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                We recommend that you back up all your personal data and perform a factory reset on your device to erase personal information. Remove any SIM cards and memory cards before the pickup.
                                            </div>
                                        </div>
                                    </div>

                                    {/* FAQ 8 */}
                                    <div className="accordion-item">
                                        <h2 className="accordion-header" id="faqHeading8">
                                            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faqCollapse8" aria-expanded="false" aria-controls="faqCollapse8">
                                                8. How can I contact Cellcash.in for more assistance?
                                            </button>
                                        </h2>
                                        <div id="faqCollapse8" className="accordion-collapse collapse" aria-labelledby="faqHeading8" data-bs-parent="#faqAccordion">
                                            <div className="accordion-body">
                                                If you need further assistance, you can reach us via email at info@cellcash.net or call our customer support line provided on our website.
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



        </>

    )
}

export default Home;